var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 131,
    viewBox: "0 0 132 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 120.083C96.3757 120.083 121 95.6455 121 65.5C121 35.3544 96.3757 10.9167 66 10.9167C35.6243 10.9167 11 35.3544 11 65.5C11 95.6455 35.6243 120.083 66 120.083Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6498 100.966C47.1659 100.966 46 99.7845 46 98.2808V30.6715C46 29.6512 46.53 28.7383 47.4308 28.3086C48.3317 27.8253 49.3916 27.9328 50.1865 28.4698L97.7753 62.3013C98.9941 63.1605 99.2591 64.8253 98.4112 66.0604C98.2522 66.3289 98.0402 66.5437 97.7753 66.7048L50.1865 100.536C49.7626 100.858 49.2326 101.02 48.6498 101.02V100.966ZM51.2994 35.8268V93.1256L91.6279 64.4494L51.2994 35.8268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.895e855000737c29562ce53f510a80e2.svg";
export { ForwardRef as ReactComponent };